import { render, staticRenderFns } from "./Side-Enum-Group.vue?vue&type=template&id=5a511c27&"
import script from "./Side-Enum-Group.vue?vue&type=script&lang=js&"
export * from "./Side-Enum-Group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports